export default "__VITE_ASSET__Ce8e7OSE__"